<template>
  <div>
    <a-spin :tip="spiningTip" :spinning="spinning" size="large">
      <div class="m-materialSet">
        <div class="u-modle-p">制作创意</div>
        <a-alert
          class="alert_class"
          message="一旦发现有上传涉毒、涉黄、涉黑等违法内容，将永久关闭后台账号，并向公安机关举报！"
          type="warning"
          show-icon
        />
        <a-form class="m-form" :form="form">
          <template>
            <div class="material_warp">
              <material-frames
                :isEdit="true"
                :isDuration="Number(isDuration)"
                :beginTime="beginTime"
                :endTime="endTime"
                :planId="planID"
                :materialSize="materialSize"
                :priceStrategy="Number(priceStrategy)"
              />
            </div>
          </template>
        </a-form>
        <div class="m-foot-btn">
          <a-button @click="lastStep">上一步</a-button>
          <a-button class="u-nextStep-btn" type="primary" @click="save">{{
            isSaveType == 1 ? '创建' : '保存'
          }}</a-button>
          <a-button style="margin-left: 32px;" type="default" @click="saveDraft"
            >存为草稿</a-button
          >
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { api } from '../../commomFun/api'
import { cacheDrafts } from '../../commomFun/cacheApi'
import materialFrames from './materialFrames/index'
import { materialSize } from '../../utils/config'
import { getplayDates } from '../../utils/utils'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
const storage = window.sessionStorage
export default {
  components: {
    materialFrames,
  },
  data() {
    return {
      spinning: false,
      spiningTip: '',
      planID: '',
      loading: false,
      // 播放时长
      isDuration: 10,
      // 播放形式
      isType: 1,
      // 保存类型：1为创建，2为编辑
      isSaveType: 1,
      headers: {
        token: '',
        uid: '',
      },
      // 当前选中的机型
      activeModelType: '',
      // 当前上传物料的机型下标（解决还在上传中切换了机型导致物料关联错误）
      uploadingModelIndex: 0,
      // 第二步选择的机型信息
      modelInfoList: [],
      // 上传的素材信息-根据机型区分
      modelMaterials: [],
      // 计划中的物料信息
      regionIdToDevId: null,
      beginTime: '', //播放开始日期
      endTime: '', //播放结束
      machineList: [], //所有已选点位集合
      materialSize: {
        w: '',
        h: '',
      }, //素材尺寸
      priceStrategy: '', //播放方式 。精准不能新增画面
    }
  },
  computed: {
    ...mapState([
      'framesList',
      'currentAdMaterialDetail',
      'framesTagColor',
      'totalPlayDateNum',
      'playDateNum',
      'selectDateList',
      'isUpload',
    ]),
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  created() {
    //将播放日期得到传递到日历组件
    const formItem = JSON.parse(storage.getItem('formItem'))
    this.beginTime =
      moment(formItem.beginTime).format('YYYY-MM-DD') + ' 00:00:00'
    this.endTime = moment(formItem.endTime).format('YYYY-MM-DD') + ' 23:59:59'
    //将头信息传递给上传物料组件
    this.priceStrategy = formItem.priceStrategy
    let userInfo = JSON.parse(window.sessionStorage.userInfo)
    this.headers.token = userInfo.token
    this.headers.uid = userInfo.userId
    //初始化vuex多画面数据
    let framesData = JSON.parse(window.sessionStorage.getItem('framesData'))
    if (framesData) {
      this.setStorageFramesData(framesData)
    }
    //绑定页面刷新监听
    window.addEventListener('beforeunload', this.saveFramesData)
  },
  mounted() {
    /**
     * 初始化获取地区信息
     */
    this.planID = window.sessionStorage.planId
    if (this.planID) {
      this.isSaveType = 2
      // this.getMaterialList(this.planID)
    } else {
      this.isSaveType = 1
    }
    this.init()
  },
  beforeDestroy() {
    //页面被销毁等，缓存多画面页面信息
    this.saveFramesData()
    //取消监听
    window.removeEventListener('beforeunload', this.saveFramesData)
  },
  methods: {
    ...mapMutations(['resetData', 'setStorageFramesData', 'resetData']),
    init() {
      const formItem = JSON.parse(storage.getItem('formItem'))
      if (formItem) {
        this.isDuration = formItem.isDuration
        // this.activeModelMaterial.isDuration = formItem.isDuration
        // 机型相关区域点位（第二步的数据），按设备型号分组，对应不同的点位信息
        this.modelInfoList = JSON.parse(sessionStorage.getItem('modelInfoList'))
        //广告尺寸
        this.materialSize = materialSize[formItem.positionId] //修改
        // 按广告尺寸分组，对应不同的物料信息
        let materialDetailsList =
          JSON.parse(sessionStorage.getItem('materialDetailsList')) || []
        //多画面功能是按画面分组,这里把所有的点位先拿出来
        this.getMachineList()
        let tempModelMaterials = []
        //之前的物料信息，待优化
        for (let modelItem of this.modelInfoList) {
          let flag = materialDetailsList.find(
            (_) =>
              Array.isArray(_.modelID) && _.modelID.includes(modelItem.modelID)
          )
          if (!!flag) {
            tempModelMaterials.push({
              ...flag,
              adSize: modelItem.adSize,
              materialSize: modelItem.materialSize,
              modelID: modelItem.modelID,
              model: modelItem.model,
              isDuration: this.isDuration,
            })
          } else {
            tempModelMaterials.push({
              adSize: modelItem.adSize,
              materialSize: modelItem.materialSize,
              modelID: modelItem.modelID,
              model: modelItem.model,
              isDuration: this.isDuration,
            })
          }
        }
        this.modelMaterials = tempModelMaterials
        // 当前默认选中第一个机型
        this.modelMaterials = this.mergeSameData(this.modelMaterials)
        // this.activeModelMaterial = this.modelMaterials[0]
        this.activeModelType = this.modelMaterials[0].adSize

        //如果存在缓存数据
      }
    },
    // 获取物料详情
    getMaterialList(planId) {
      let editPlanDetail = JSON.parse(sessionStorage.getItem('editPlanDetail'))
      if (planId != editPlanDetail.planId) return
      if (Array.isArray(editPlanDetail.adMaterials)) {
        this.regionIdToDevId = {}
        editPlanDetail.adMaterials.forEach((item) => {
          // 将该设备在当前计划中的唯一id（regionId）与设备id相关联
          item.adMachines.forEach((devItem) => {
            this.regionIdToDevId[devItem.devId] = devItem.regionId
          })
        })
      } else {
        this.regionIdToDevId = []
        console.log('该计划物料信息为空')
      }
    },
    async saveDraft() {
      const formItem = sessionStorage.getItem('formItem')
      let data = {}
      try {
        data = JSON.parse(formItem)
      } catch {
        data = {}
      }
      const { planName } = data
      const selectedList = await this.$localForage.getItem('selectedList')
      const params = {
        planName,
        planInfo: formItem,
        draftId: sessionStorage.getItem('draftId') || '',
        devInfo: JSON.stringify({
          ...this.cacheData(),
          selectedList: selectedList
        }),
      }
      api.postApi_header('/draft/plan/save', '', params).then((res) => {
        const { code, data } = res.data
        if (code === 200) {
          sessionStorage.setItem('draftId', data)
          this.$message.success('存为草稿成功')
          setTimeout(() => this.$router.push('/channelAdPlan'), 300)
        }
      })
    },
    async cacheData() {
      // const selectedList = sessionStorage.getItem('selectedList')
      // const selectedList = await this.$localForage.getItem('selectedList')
      const areaDataListRow = sessionStorage.getItem('areaDataListRow')
      const selectedInfo = sessionStorage.getItem('selectedInfo')
      const modelInfoList = sessionStorage.getItem('modelInfoList') //保留
      const conditionList = sessionStorage.getItem('conditionList') //保留
      // sessionStorage.getItem('targetSetType', 'createing');
      //储存vuex中的数据
      const framesData = {
        framesList: this.framesList,
        currentAdMaterialDetail: this.currentAdMaterialDetail,
        framesTagColor: this.framesTagColor,
        totalPlayDateNum: this.totalPlayDateNum,
        selectDateList: this.selectDateList,
        playDateNum: this.playDateNum,
        isUpload: this.isUpload,
      }
      const devInfo = {
        // selectedList,
        areaDataListRow,
        selectedInfo,
        modelInfoList,
        conditionList,
        framesData,
      }
      return devInfo
    },
    //合并相同adSize的数据
    mergeSameData(arr) {
      let hash = {}
      let i = 0
      let res = [] //结果数组
      arr.forEach(function (item) {
        var adSize = item.adSize
        if (hash[adSize]) {
          //有相同的id的对象,把regionDirections合并到第一个对象里
          res[hash[adSize] - 1].model = res[hash[adSize] - 1].model.concat([
            item.model,
          ])
          res[hash[adSize] - 1].modelID = res[hash[adSize] - 1].modelID.concat([
            item.modelID,
          ])
        } else {
          //没有相同的id
          hash[adSize] =
            ++i &&
            res.push({
              ...item,
              model: typeof item.model == 'string' ? [item.model] : item.model,
              modelID:
                typeof item.model == 'string' ? [item.modelID] : item.modelID,
            })
        }
      })
      return res
    },
    // 创建计划第一步
    create() {
      this.spiningTip = '正在创建计划...'
      this.spinning = true
      let hide = this.$message.loading('加载中...')
      //处理数据
      let info = this.getCreatePlanInfo()
      //发送请求
      this.createPlan(info, hide)
    },
    // 编辑
    upDate() {
      this.spiningTip = '正在保存计划...'
      this.spinning = true
      let hide = this.$message.loading('加载中...')
      let editInfo = this.getUpdatePlanInfo()
      //修改广告计划
      this.updatePlan(editInfo, hide)
    },
    //上一步
    lastStep() {
      sessionStorage.setItem('materialSetType', 'createing')
      this.sessionSetItem('materialDetailsList', this.modelMaterials)
      // sessionStorage.removeItem('materialDetailsList')
      //缓存vuex数据
      this.saveFramesData()
      this.$router.push('./channelTargetSet')
    },
    save() {
      if (this.isSaveType == 1) {
        // 创建计划
        this.create()
      } else {
        // 编辑计划
        this.upDate()
      }
    },
    // 公用方法缓存
    sessionSetItem(name, data) {
      sessionStorage.setItem(name, JSON.stringify(data))
    },
    //得到所有选择点位的id
    getMachineList() {
      this.modelInfoList.forEach((item) => {
        item.regionDirections.forEach((i) => {
          this.machineList.push({
            devId: i.regionValue,
            pointId: i.regionCode,
            regionId: null,
          })
        })
      })
    },
    //获取创建订单请求参数
    getCreatePlanInfo() {
      let adMaterials = this.getAdMaterials('creat')
      let formItem = JSON.parse(sessionStorage.getItem('formItem'))
      let info = {
        adMaterials,
        // 广告主id 默认1
        advertiserId: formItem.companyId,
        // 广告主名称 eg: 京东集团
        advertiserName: formItem.companyName,
        beginTime:
          moment(formItem.beginTime).format('YYYY-MM-DD') + ' 00:00:00',
        channelId: 1,
        endTime: moment(formItem.endTime).format('YYYY-MM-DD') + ' 23:59:59',
        industryName: formItem.adSystemName,
        // 媒体类型： LED屏
        mediaType: 1,
        planName: formItem.planName,
        playCount: Number(formItem.playCounts),
        playDuration: formItem.playSecond,
        positionId: formItem.positionId,
        priceStrategy: formItem.priceStrategy,
        originCompanyId: formItem.originCompanyId,
        originCompanyName: formItem.originCompanyName || '',
        originUserId: formItem.originUserId,
        originUserName: formItem.originUserName || '',
        companyId: formItem.companyId,
        companyName: formItem.companyName || '',
        brandId: formItem.companyBrandId,
        brandName: formItem.companyBrand || '',
        deliveryPeriod: formItem.deliveryPeriod || 3, //播放时段 后端说触发默认传3
        // CPM(1,"CPM"),CPT(2,"CPT")
        settlementType: formItem.priceStrategy == 2 ? 1 : 2,
        precises: JSON.parse(sessionStorage.getItem('conditionList')),
      }
      if (formItem.saleId !== '') {
        info.saleId = formItem.saleId
      }
      if (formItem.priceStrategy == 1) {
        // 销售收入（刊例价）
        info.price = formItem.price
      }
      return info
    },
    // 得到创建订单画面信息
    getAdMaterials(type) {
      let adMaterials = []
      let _framsList = JSON.parse(JSON.stringify(this.framesList))
      let formItem = JSON.parse(sessionStorage.getItem('formItem'))
      //创建和编辑不一样的参数
      let planId = ''
      let machineList = []
      let materialId = ''
      if (type == 'creat') {
        planId = null
        materialId = null
        machineList = this.machineList
      } else if (type == 'edit') {
        try {
          var editPlanDetail = JSON.parse(
            sessionStorage.getItem('editPlanDetail')
          )
          if (!editPlanDetail) {
            this.$message.warning('计划详情获取异常！')
            return
          }
        } catch (error) {}
        planId = editPlanDetail.planId
        materialId = editPlanDetail.adMaterials[0].materialId
        machineList = this.machineList.map((item) => {
          item.regionId = editPlanDetail.regionIdToPointId[item.pointId]
          return item
        })
      }

      _framsList.forEach((item, index) => {
        adMaterials.push({
          adMaterialDetail: item.adMaterialDetail.fileId
            ? {
                materialNumber: index + 1,
                playDates: getplayDates(item.playDates),
                materialName: item.framesName,
                tagColor: item.tagColor,
                adSpace: 3,
                createTime: '',
                createUserId: JSON.parse(sessionStorage.userInfo).userId,
                fileCryptUrl: item.adMaterialDetail.fileCryptUrl,
                fileId: item.adMaterialDetail.fileId,
                fileMd5: item.adMaterialDetail.fullImageFileMd5,
                fileName: item.adMaterialDetail.fullImageName,
                fileType: item.adMaterialDetail.fileType,
                fileUrl: item.adMaterialDetail.fullImageUrl,
                materialInfo: item.adMaterialDetail.materialInfo,
                planId,
                status: 0,
                type: 0,
                updateTime: '',
                videoSnapshotUrl: item.adMaterialDetail.videoSnapshotUrl,
              }
            : {
                materialNumber: index + 1,
                playDates: getplayDates(item.playDates),
                materialName: item.framesName,
                tagColor: item.tagColor,
              },
          adTimesLimit: formItem.playCounts,
          adType: 1,
          beginTime:
            moment(formItem.beginTime).format('YYYY-MM-DD') + ' 00:00:00',
          createTime: '',
          // deviceModel: null,
          // deviceModelText: null,
          endTime: moment(formItem.endTime).format('YYYY-MM-DD') + ' 23:59:59',
          machineList,
          precises: JSON.parse(sessionStorage.getItem('conditionList')),
          materialDesc: '',
          materialId,
          planId,
          playDuration: formItem.playSecond,
          playTimes: Number(formItem.playCounts),
          // 全屏、分屏，默认1
          playType: 1,
          remark: '',
          schStatus: 0,
          status: 0,
          unitPrice: 0,
        })
      })
      return adMaterials
    },
    //创建订单 info 请求参数  hide 关闭loading
    createPlan(info, hide) {
      api
        .postApi('/adPlan/create', info)
        .then((res) => {
          if (res.data.code === 200 && res.data.data.planId) {
            sessionStorage.setItem('planId', res.data.data.planId)
            api
              .postApi_header('/draft/plan/removeCache', '', {})
              .then((res) => {
                console.log('清除缓存成功')
              })
            api
              .postApi_header('/draft/plan/delete', '', {
                draftId: sessionStorage.getItem('draftId'),
              })
              .then((res) => {
                const { code } = res.data
                if (code === 200) {
                  sessionStorage.setItem('draftId', '')
                }
              })
            //重置vuex画面信息
            this.resetData()
            //重置缓存方法，避免清除缓存后离开页面又进行缓存
            this.saveFramesData = () => {}
            this.$router.push('./channelAdPlanDetail')
          } else {
            this.$message.warning(res.data.msg)
          }
          setTimeout(hide, 500)
        })
        .catch((err) => {
          console.log(err)
          setTimeout(hide, 500)
        })
        .finally(()=>{
          this.spinning = false
        })
    },
    // 缓存vuex数据
    async saveFramesData() {
      let date = {
        framesList: this.framesList,
        currentAdMaterialDetail: this.currentAdMaterialDetail,
        framesTagColor: this.framesTagColor,
        totalPlayDateNum: this.totalPlayDateNum,
        selectDateList: this.selectDateList,
        playDateNum: this.playDateNum,
        isUpload: this.isUpload,
      }
      sessionStorage.setItem('framesData', JSON.stringify(date))
      //如果是新建状态才缓存到远程
      if (this.isSaveType == 1) {
      const selectedList = await this.$localForage.getItem('selectedList')
        cacheDrafts(3, { devInfo: JSON.stringify({
          ...this.cacheData(),
          selectedList: selectedList
        }) })
      }
    },
    // 下载图片
    downloadImg(url, name) {
      var _this = this
      var canvas = document.createElement('canvas')
      var img = document.createElement('img')

      img.onload = function (e) {
        canvas.width = img.width
        canvas.height = img.height
        var context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, img.width, img.height)
        // canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
        canvas.toBlob((blob) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = name
          link.click()
        }, 'image/png')
      }
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = url
    },
    getUpdatePlanInfo() {
      let adMaterials = this.getAdMaterials('edit')
      let formItem = JSON.parse(sessionStorage.getItem('formItem'))
      let editPlanDetail = JSON.parse(sessionStorage.getItem('editPlanDetail'))
      if (!editPlanDetail) {
        this.$message.warning('计划详情获取异常！')
        return
      }
      let info = {
        adMaterials,
        // 广告主id 默认1
        advertiserId: formItem.companyId,
        // 广告主名称 eg: 京东集团
        advertiserName: formItem.companyName,
        beginTime:
          moment(formItem.beginTime).format('YYYY-MM-DD') + ' 00:00:00',
        channelId: editPlanDetail.channelId,
        endTime: moment(formItem.endTime).format('YYYY-MM-DD') + ' 23:59:59',
        industryName: formItem.adSystemName,
        // 媒体类型： LED屏
        mediaType: 1,
        planId: editPlanDetail.planId,
        planName: formItem.planName,
        playCount: Number(formItem.playCounts),
        playDuration: formItem.playSecond,
        positionId: formItem.positionId,
        priceStrategy: formItem.priceStrategy,
        originCompanyId: formItem.originCompanyId,
        originCompanyName: formItem.originCompanyName || '',
        originUserId: formItem.originUserId,
        originUserName: formItem.originUserName || '',
        companyId: formItem.companyId,
        companyName: formItem.companyName || '',
        brandId: formItem.companyBrandId,
        brandName: formItem.companyBrand || '',
        deliveryPeriod: formItem.deliveryPeriod || 3, //播放时段 后端说触发默认传3
        // CPM(1,"CPM"),CPT(2,"CPT")
        settlementType: formItem.priceStrategy == 2 ? 1 : 2,
        precises: JSON.parse(sessionStorage.getItem('conditionList')),
        status: editPlanDetail.status,
        version: editPlanDetail.version,
      }
      if (formItem.priceStrategy == 1) {
        // 销售收入（刊例价）
        info.price = formItem.price
      }
      return info
    },
    //编辑订单保存
    updatePlan(editInfo, hide) {
      api
        .postApi('/adPlan/update', editInfo)
        .then((res) => {
          if (res.data.code === 200) {
            // sessionStorage.setItem("planId", res.data.data.planId);
            setTimeout(hide, 500)
            this.spinning = false
            //重置vuex画面信息
            this.resetData()
            //重置缓存方法，避免清除缓存后离开页面又进行缓存
            this.saveFramesData = () => {}
            this.$router.push('./channelAdPlanDetail')
          } else {
            this.spinning = false
            this.$message.warning(res.data.msg)
          }
          setTimeout(hide, 500)
        })
        .catch((err2) => {
          this.spinning = false
          setTimeout(hide, 500)
          console.log(err2)
        })
    },
  },
}
</script>
<style scoped lang="scss">
.m-materialSet {
  .u-modle-p {
    width: 100%;
    height: 42px;
    background: rgba(240, 242, 245, 0.41);
    font-size: 18px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 42px;
    padding-left: 24px;
    margin-bottom: 32px;
  }
  .alert_class {
    width: 913px;
    margin: 0 auto 16px;
  }
}

.material_warp {
  width: 913px;
  /*height: 616px;*/
  height: 520px;
  margin: 0 auto 24px;
  display: flex;
  // border: 1px solid rgba(233, 233, 233, 1);

  .left_tags {
    height: 517px;
    overflow-y: scroll;
    width: 304px;
    padding: 16px 12px;
    border-right: 1px solid rgba(233, 233, 233, 1);
  }

  .right_conten {
    width: 304px;
    border-right: 1px solid rgba(233, 233, 233, 1);
  }
  .calendar_wrapper {
    width: 305px;
  }
}

.m-foot-btn {
  margin-top: 32px;
  text-align: center;
  .ant-btn:nth-child(1) {
    margin-right: 32px;
  }
}

.ant-form-item-control-wrapper {
  width: auto;
}

.u-show-img {
  img {
    width: 100%;
    height: 100%;
  }
}

.u-show-video {
  video {
    width: 100%;
    height: 100%;
  }
}

.u-show-img,
.u-show-video {
  .ant-modal-footer {
    .ant-btn-primary {
      display: none;
    }
  }
}
</style>
